export default {
  unavailable: {
    title: 'Tämä palvelu on Foodamigosin tarjoama',
    description:
      'Lentolehtisten ja tarrojen tulostus on Foodamigos-tiimin tarjoama palvelu, eikä se ole käytettävissä kumppanitileille.',
  },
};
